export default __webpack_public_path__ + "static/media/kanban-edit.6dcf8f9b.svg";